// External
import { useQuery } from '@tanstack/react-query';

// API
import { getOperatingHour, operatingHoursQueryKeys } from '@api/operatingHours';

// Types
import type { OperatingHourShowResponse } from '@api/operatingHours';

const STALE_TIME = 30_000;

interface UseOperatingHourOptions {
  initialData?: OperatingHourShowResponse;
  enabled?: boolean;
}

export function useOperatingHour(id: number, options?: UseOperatingHourOptions) {
  const { initialData, enabled } = options ?? {};

  return useQuery({
    queryKey: operatingHoursQueryKeys.detail(id),
    queryFn: () => getOperatingHour(id),
    staleTime: STALE_TIME,
    enabled: enabled ?? id > 0,
    ...(initialData ? { initialData, initialDataUpdatedAt: Date.now() } : {}),
  });
}
